import { render, staticRenderFns } from "./formProduct.vue?vue&type=template&id=4d1e77a0&"
import script from "./formProduct.vue?vue&type=script&lang=js&"
export * from "./formProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports